// Help articles, shared by the help overview page and the quick find in the header

import routes from '@config/routes';

export type HelpArticle = {
  /** Key of the article under help.* in the translations: help.<id> is the title,
   * help.descriptions.<id> the description and help.content.<id> the text. */
  id: string;
  path: string;
};

const helpArticles: HelpArticle[] = [
  { id: 'gettingStarted', path: routes.helpGettingStarted },
  { id: 'authentication', path: routes.helpAuthentication },
  { id: 'files', path: routes.helpFiles },
  { id: 'datasets', path: routes.helpDatasets },
  { id: 'tpsMapping', path: routes.helpTpsMapping },
  // { id: 'map', path: routes.helpMap },
  { id: 'tools', path: routes.helpTools },
  { id: 'reports', path: routes.helpReports },
  { id: 'dataCatalog', path: routes.helpDataCatalog },
  { id: 'dereferencing', path: routes.helpDereferencing },
  { id: 'dataLineage', path: routes.helpDataLineage },
  { id: 'definitions', path: routes.helpDefinitions },
  { id: 'accessibility', path: routes.helpAccessibility },
  { id: 'support', path: routes.helpSupport },
];

export default helpArticles;
